import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  AlertController,
  LoadingController,
  ModalController,
  Platform,
  PopoverController,
} from '@ionic/angular';
import { isBefore, isSameDay, lastDayOfMonth, startOfMonth, subMonths } from 'date-fns';
import { UserRoot } from 'src/providers/apiservices/UsuarioLogado';
import { DevUtils } from 'src/providers/apiservices/Utils';
import { Events } from 'src/providers/apiservices/eventsservice';
import {
  GlobalService,
  ToastColors,
} from 'src/providers/apiservices/globalservices';
import { LocalStorageProvider } from 'src/providers/apiservices/localstorageprovider';
import { AuditoriaProvider } from 'src/providers/auditoria/auditoria';
import {
  ComunicacaoProvider,
  ComunicacaoTexto,
} from 'src/providers/comunicacao/comunicacao';
import { ContratoProvider } from 'src/providers/contrato/contrato';
import { TarefasProvider } from 'src/providers/tarefas/tarefas';
import { UserConfigDto } from 'src/providersdata/UserConfigDto';
import messages from '../../../assets/data/messages.json';
import { ControleCienteProvider } from "../../../providers/controleciente/controleciente";
import { AuditDetailPage } from '../audit-detail/audit-detail.page';
import {
  CreatecomunicadoPage,
  IdTipoComunicado,
} from '../createcomunicado/createcomunicado.page';
import { TimelinereadPage } from '../message/timelineread/timelineread.page';
import {
  IViewArquivosData,
  IViewMessagesData,
  MessageController,
} from './message.control';
import { MESSAGE_STAGE_ENUM } from './message.enum';
import { APIService } from 'src/providers/apiservices/apiservices';


interface Destinatario {
  name: string;
  id: string;
  code: string;
}


@Component({
  selector: 'app-message-comunicacao',
  templateUrl: './message-comunicacao.page.html',
  styleUrls: ['./message-comunicacao.page.scss'],
})
export class MessageComunicacaoPage implements OnInit {
  /**
   * Usado para Comunicação, Notificação, Solicitação e Promoção
   */
  MessageControl: MessageController = new MessageController();

  @ViewChild('InputFile') inputFile: ElementRef<HTMLInputElement>;

  @Input() numContrato = "";

  public currentDate = new Date().toISOString().split('T')[0];
  public isAdmin = false;
  public isLoadingMensagem = true;
  public idComunicacao: number = null;
  public bdComunicacaoData: ComunicadoDTO.IdComunicacaoNavigation = null;
  public isTarefa: boolean = false;
  public stores = [];
  public view: string | null = null;
  public tarefa: any = null;
  public isPreview: boolean = false; // Não sei se será usado ainda
  public replyTextObject: any = null;
  public replyTextHistory: ComunicacaoTexto[] = [];
  public replyText: string = '';
  public replyQueroParticipar = null;
  public comunicadoEditado: boolean = false;

  leituras = {
    lidas: [],
    naoLidas: [],
  };
  todasLeituras = [];
  loadingLeituras: boolean = false;
  totalDestinatarios: number = 0;
  isMobile: boolean = false;
  isModalReprovacao: boolean = false;
  isModalAlterarDataLimite: boolean = false;
  justificativaReprovacao: string = '';
  justificativaAlteracaoDataLimite: string = '';

  dataLimiteAtualizacao: string = null;

  currentMessage: IViewMessagesData;

  MESSAGE_STAGE_ENUM = MESSAGE_STAGE_ENUM;

  public RIGHT_SIDEBAR_VIEW = {
    SHOW_APROVADOR: true,
    SHOW_REMETENTE: true,
    SHOW_CONTRATO: true,
    SHOW_SHOPPING: true,
    SHOW_ORIGEM: true,
    SHOW_DESTINATARIOS: true,
    SHOW_LOJAS_COMUNICADAS: true,
    SHOW_LIDOS: false,
    SHOW_LOJAS_PARTICIPANTES_PROMOCAO: false,
    SHOW_PENDENTES_RESPOSTA: true,
  };

  // Destinatários auditoria
  public filteredContratosDestinatarios = this.MessageControl.viewData.contratos || [];
  public tmpFilteredContratosDestinatarios = [];
  querySearchBarDestinatarios = ""
  querySearchBarAuditorias = ""
  canViewAuditModule: boolean = false;

  public get isUsuarioMultiplan() {
    return !!this.userConfig?.isUsuarioMultiplan
  }

  constructor(
    private modalCtrl: ModalController,
    private comunicacaoProvider: ComunicacaoProvider,
    private auditoriaProvider: AuditoriaProvider,
    private globalService: GlobalService,
    private loadingController: LoadingController,
    private popoverController: PopoverController,
    private tarefasProvider: TarefasProvider,
    private AlertController: AlertController,
    private domSanitizer: DomSanitizer,
    private events: Events,
    private localStorage: LocalStorageProvider,
    private contratoProvider: ContratoProvider,
    private controleCienteProvider: ControleCienteProvider,
    private platform: Platform,
    private router: Router
  ) {}

  selected_lojas_comunicadas = "comunicadas";
  selected_leituras = "lidas";
  selected_destinatario = null;
  selected_destinatario_auditorias = [];
  filtered_selected_destinatario_auditorias = []
  handleLeiturasChange($event)
  {
    if(!$event?.detail?.value)
      return;

    this.tmpFilteredContratosDestinatarios = [];

    this.applyDestinatariosFilter()
  }

  handleContratosChange($event) {
    if(!$event?.detail?.value)
      return;

    this.tmpFilteredContratosDestinatarios = [];

    this.applyDestinatariosFilter()
  }

  applyDestinatariosFilter(selectedLojasComunicadas = null, selectedLeituras = null) {

    if(this.selected_lojas_comunicadas != 'comunicadas')
    {
      
      this.filteredContratosDestinatarios = this.MessageControl.lojasNaoComunicadas;
      return;
    }

    this.filteredContratosDestinatarios = this.MessageControl.viewData.contratos;

    let contratosNaoLidos = this.leituras.naoLidas.map(x => x.numContrato);
    if(this.selected_leituras == "lidas")
    {
      this.filteredContratosDestinatarios = this.filteredContratosDestinatarios.filter(
        (contrato) => !contratosNaoLidos.includes(contrato.numContrato)
      );
    } 
    else 
    {
      this.filteredContratosDestinatarios = this.filteredContratosDestinatarios.filter(
        (contrato) => contratosNaoLidos.includes(contrato.numContrato)
      );
    }
  }

  loadDestinatarioAuditoria(contrato)
  {
    if(this.selected_lojas_comunicadas != 'comunicadas')
    {
      return;
    }

    console.log('loadDestinatarioAuditoria', contrato);

    this.selected_destinatario = contrato;

    this.buscarAuditoriaContrato();
  }

  async buscarAuditoriaContrato()
  {
    if (!this.selected_destinatario) {
      this.globalService.presentToast(
        'Selecione um contrato para buscar a auditoria.',
        ToastColors.danger
      );
      return;
    }

    this.selected_destinatario_auditorias = [];
    this.filtered_selected_destinatario_auditorias = [];

    const loading = await this.loadingController.create({
      message: 'Carregando auditoria do contrato...',
    });

    loading.present();

    try {
      const response = await this.auditoriaProvider.get(
        {
          codigoItem: `${this.idComunicacao}`,
          modulo: "6",
          tipoVisualizacaoLogs: "VER-LOJISTA"
        }, 1000
      );

      console.log(response)

      if (response.erro) {
        throw new Error(response.erro);
      }

      this.selected_destinatario_auditorias = response.Item.retorno;
      this.filtered_selected_destinatario_auditorias = this.selected_destinatario_auditorias
    } catch (error) {
      console.error(error);
      this.globalService.presentToast(
        'Não foi possível carregar a auditoria do contrato.',
        ToastColors.danger
      );
    } finally {
      loading.dismiss();
    }
  }

  handleInput(event: any) {
    // console.log('handleInput', event);
    const query = event.target.value.toLowerCase();

    if(!query)
    {
      this.tmpFilteredContratosDestinatarios = [];
      return;
    }

    this.tmpFilteredContratosDestinatarios = DevUtils.searchInArray(this.filteredContratosDestinatarios, query, ['nomContrato', 'numContrato', 'lucLoja']);
  }

  handleInputAuditorias(event: any) {
    // console.log('handleInput', event);
    const query = event.target.value.toLowerCase();

    if(!query)
    {
      this.filtered_selected_destinatario_auditorias = this.selected_destinatario_auditorias;
      return;
    }

    this.filtered_selected_destinatario_auditorias = DevUtils.searchInArray(this.selected_destinatario_auditorias, query, ['acao', 'login']);
  }

  // Current user data;
  public user: UserRoot = null;
  public userConfig: UserConfigDto = null;
  ngOnInit() {
    const localStorageData = this.localStorage.loggedUser;
    this.isAdmin = localStorageData.Config.tipoUsuario == 1;
    this.user = localStorageData.Usuario;
    this.userConfig = localStorageData.Config;
    this.canViewAuditModule = this.hasAuditModuleAccess();

    if (this.platform.is('ios') || this.platform.is('android')) {
      this.isMobile = true;
    }
    this.filteredItems = [...this.allItems];

    if (this.isPreview) {
      this.loadPreview();
    } else {
      this.loadComunicado(this.idComunicacao);
    }
  }

  private hasAuditModuleAccess(): boolean {
    const contratoLoginPerfils = this.localStorage?.loggedUser?.Usuario?.contratoLoginPerfils;

    if (!Array.isArray(contratoLoginPerfils)) {
      return false;
    }

    const allowedActivities = ['3', '4'];

    return contratoLoginPerfils.some((perfil) => {
      const ids = perfil?.idPerfilNavigation?.ids;

      if (!Array.isArray(ids)) {
        return false;
      }

      return ids.some(
        (atividade) =>
          Number(atividade?.idModulo) === 1 &&
          allowedActivities.includes(String(atividade?.idAtividade))
      );
    });
  }

  async loadPreview() {
    const comunicacaoData = this.bdComunicacaoData;

    if (!comunicacaoData) return this.dismiss();

    await this.getStores(comunicacaoData?.comunicacaoContratos[0]?.idEmpresa).catch(console.error);

    console.log('getStores', this.stores);

    this.MessageControl = new MessageController({
      comunicacao: comunicacaoData,
      idComunicacao: this.idComunicacao,
      loadingController: this.loadingController,
      tarefa: this.tarefa,
      stores: this.stores,
      preview: true,
      view: this.view,
    });

    this.isLoadingMensagem = false;
    this.loadRightSidebarView();

    this.globalService.devlog('viewData', this.MessageControl.viewData);
  }

  loadRightSidebarView() {
    let changeRightSidebarView = this.RIGHT_SIDEBAR_VIEW;
    changeRightSidebarView.SHOW_DESTINATARIOS = true;

    if (this.MessageControl.isTarefa && this.isAdmin && !this.isPreview) {
      changeRightSidebarView.SHOW_APROVADOR = true;
      changeRightSidebarView.SHOW_REMETENTE = true;
      changeRightSidebarView.SHOW_CONTRATO = true;
      changeRightSidebarView.SHOW_SHOPPING = true;
      changeRightSidebarView.SHOW_ORIGEM = true;
      changeRightSidebarView.SHOW_DESTINATARIOS = true;
      changeRightSidebarView.SHOW_LOJAS_COMUNICADAS = true;
      changeRightSidebarView.SHOW_PENDENTES_RESPOSTA = true;
    }

    if (
      this.MessageControl.isTarefa == false &&
      this.isAdmin == false &&
      this.isPreview == false
    ) {
      changeRightSidebarView.SHOW_REMETENTE = true;
      changeRightSidebarView.SHOW_SHOPPING = true;
      changeRightSidebarView.SHOW_ORIGEM = true;
    }

    if (
      this.MessageControl.isTarefa == false &&
      this.isAdmin == true &&
      this.isPreview == false
    ) {
      changeRightSidebarView.SHOW_REMETENTE = true;
      changeRightSidebarView.SHOW_APROVADOR = true;
      changeRightSidebarView.SHOW_ORIGEM = true;
      changeRightSidebarView.SHOW_SHOPPING = true;
      changeRightSidebarView.SHOW_CONTRATO = true;
      changeRightSidebarView.SHOW_LOJAS_COMUNICADAS = true;
    }

    if (this.isPreview) {
      changeRightSidebarView.SHOW_REMETENTE = true;
      changeRightSidebarView.SHOW_APROVADOR = true;
      changeRightSidebarView.SHOW_SHOPPING = true;
      changeRightSidebarView.SHOW_CONTRATO = true;
      changeRightSidebarView.SHOW_ORIGEM = true;
      changeRightSidebarView.SHOW_LOJAS_COMUNICADAS = true;
      changeRightSidebarView.SHOW_PENDENTES_RESPOSTA = true;
    }

    if (this.view == 'consulta' && this.MessageControl.isPromocao) {
      changeRightSidebarView.SHOW_LOJAS_COMUNICADAS = false;
      changeRightSidebarView.SHOW_LOJAS_PARTICIPANTES_PROMOCAO = true;
    }

    if(!this.userConfig.isUsuarioMultiplan)
    {
      changeRightSidebarView.SHOW_DESTINATARIOS = false;
    }
    else
    {
      changeRightSidebarView.SHOW_DESTINATARIOS = true;

      if(this.MessageControl.isComunicacao || this.MessageControl.isNotificacao)
      {
        changeRightSidebarView.SHOW_LIDOS = true;
      }
    }

    if(this.MessageControl.isSolicitacao || this.MessageControl.isComunicacao || this.MessageControl.isNotificacao) {
      changeRightSidebarView.SHOW_PENDENTES_RESPOSTA = false;
    }

    this.globalService.devlog(this.view, this.MessageControl, this.userConfig)

    this.RIGHT_SIDEBAR_VIEW = changeRightSidebarView;
  }

  get showRightSidebar(): boolean {
    return (
      this.MessageControl.isTarefa == false &&
      this.isAdmin == true &&
      this.isPreview == false
    );
  }

  get showRightSidebarPreview(): boolean {
    return this.isPreview == true;
  }

  get showRightSidebarUser(): boolean {
    return (
      this.MessageControl.isTarefa == false &&
      this.isAdmin == false &&
      this.isPreview == false
    );
  }

  get showRightSidebarRespostaLojista(): boolean {
    return (
      this.MessageControl.isTarefa == true &&
      this.isPreview == false &&
      this.MessageControl.isReply
    );
  }

  get showRightSidebarTarefa(): boolean {
    return (
      this.MessageControl.isTarefa == true &&
      this.isAdmin == true &&
      this.isPreview == false
    );
  }

  get canDeleteCommunication() {
    if(!this.userConfig.isUsuarioMultiplan)
      return false;

    return (this.MessageControl.MESSAGE_STAGE == this.MESSAGE_STAGE_ENUM.AVALIAR_CRIACAO
    || this.MessageControl.MESSAGE_STAGE == this.MESSAGE_STAGE_ENUM.AJUSTAR_CRIACAO
    || this.MessageControl.MESSAGE_STAGE == this.MESSAGE_STAGE_ENUM.AVALIAR_DATA_LIMITE_EXCEDIDA_APROVADOR
    || this.MessageControl.MESSAGE_STAGE == this.MESSAGE_STAGE_ENUM.AJUSTE_DATA_LIMITE_EXCEDIDA_CRIADOR)
  }

  checkLojistaParticipara($event) {
    //console.log("Lojista participara?", $event)
    if ($event?.detail?.value) this.replyQueroParticipar = $event.detail.value;
  }

  getArquivoByIdTexto(idTexto: number) {
    //console.log(idTexto, this.MessageControl.comunicacao.comunicacaoArquivos)
    return Array.isArray(this.MessageControl.comunicacao.comunicacaoArquivos)
      ? this.MessageControl.comunicacao.comunicacaoArquivos
          .filter((x) => x.idTexto == idTexto)
          .map((arquivo) => {
            return {
              idArquivo: arquivo.idArquivo,
              idGestorDocumentos:
                arquivo.idArquivoNavigation.idGestorDocumentos,
              title: arquivo.idArquivoNavigation.nomeArquivo,
            } as IViewArquivosData;
          })
      : [];
  }

  setOpenModalReprovacao(isOpen: boolean) {
    this.justificativaReprovacao = '';
    this.isModalReprovacao = isOpen;
  }

  setOpenModalAlterarDataLimite(isOpen: boolean) {
    this.justificativaReprovacao = '';
    this.isModalAlterarDataLimite = isOpen;
  }

  // destinatarios

  allItems: Destinatario[] = [
    { name: 'JOPAR', id: '(0000010000000)', code: '106P36' },
    { name: 'JOPAR', id: '(0000010000001)', code: '111A' },
    { name: 'PORTMAN', id: '(0000010000005)', code: '205' },
    { name: 'LOUNGERIE', id: '(0000010000007)', code: '220E' },
    { name: 'C&A', id: '(0000010000010)', code: 'A' },
    { name: 'BABIES', id: '(0000020000006)', code: '102C1' },
    { name: 'BY TENNIS', id: '(0000020000008)', code: '102E' },
    { name: 'CORI', id: '(0000020000010)', code: '103A' },
  ];
  filteredItems: Destinatario[] = [];




  async getStores(idEmpresa = null) {
    idEmpresa =
      idEmpresa || this.MessageControl.viewData.contratos[0]?.idEmpresa;

    if (!idEmpresa) return;

    await this.contratoProvider.getContratoSegmentos(idEmpresa).then((res) => {
      
      if(!Array.isArray(res.Item))
        return null;

      res.Item = res.Item.filter(store => store.dtRescisao == null);
      
      this.stores = res.Item;
      if (APIService.UsuarioLogado.Usuario.idTipoUsuario!=1){
        this.stores=res.Item;
      }
        else{
          if (res.Item) {
            this.stores = [];

            let usu = APIService.UsuarioLogado.Usuario;

            const isTodsEmpresas = usu.contratoLoginPerfils.find(
              (x) =>
                x.idEmpresa.startsWith('TODS') || x.idEmpresa === 'TODOS_TODS'
            )
              ? true
              : false;
            const isTodsContratos = usu.contratoLoginPerfils.find(
              (x) =>
                x.numContrato.startsWith('TODS') ||
                x.numContrato.startsWith('TODOS')
            )
              ? true
              : false;

            let _segmentos = [];

            res.Item.flatMap((item) => item.idSegmentos).forEach((item) => {
              if (_segmentos.find((x) => x.idSegmento == item.idSegmento)) {
                return;
              }

              _segmentos.push({
                title: item.desSegmento,
                value: item.idSegmento,
                idSegmento: item.idSegmento,
                desSegmento: item.desSegmento,
              });
            });
            
            var lastDayOfPastMonth = lastDayOfMonth(subMonths(new Date(), 1));
            var primeiroDiaDoMesAtual = startOfMonth(new Date());
            if (this.userConfig.isUsuarioMultiplan) {
              this.stores = res.Item.filter(store => store.dtRescisao == null || new Date(store.dtRescisao) >= primeiroDiaDoMesAtual || new Date(store.dtRescisao) > new Date(this.MessageControl.viewData.contratos[0]?.idEmpresaNavigation?.dtAberturaAdm))
            } else {
              this.stores = res.Item.filter(store => store.dtRescisao == null || new Date(store.dtRescisao) >= primeiroDiaDoMesAtual || new Date(store.dtRescisao) > new Date(this.MessageControl.viewData.contratos[0]?.idEmpresaNavigation?.dtAberturaLoja))
            }

            if (isTodsEmpresas && isTodsContratos) {
              this.stores = this.stores.map((item) => {
                return {
                  ...item,
                  title: `${item.nomContrato} (${item.lucLoja} - ${item.numContrato})`,
                  value: item.numContrato,
                  segmento:
                    item.idSegmentos[0] == undefined ? null : item.idSegmentos[0],
                  idSegmento:
                    item.idSegmentos[0] == undefined
                      ? null
                      : item.idSegmentos[0]['idSegmento'],
                };
              });
            } else if (!isTodsEmpresas && isTodsContratos) {
              this.stores = this.stores.filter(
                (store) => store.numContrato
              ).map((item) => {
                return {
                  ...item,
                  title: `${item.nomContrato} (${item.lucLoja} - ${item.numContrato})`,
                  value: item.numContrato,
                  segmento:
                    item.idSegmentos[0] == undefined ? null : item.idSegmentos[0],
                  idSegmento:
                    item.idSegmentos[0] == undefined
                      ? null
                      : item.idSegmentos[0]['idSegmento'],
                };
              });
            } else {
              const contratosByShoppingSelecionado =
                usu.contratoLoginPerfils.filter(
                  (x) => x.idEmpresa == this.MessageControl.viewData.contratos[0]?.idEmpresaNavigation?.idEmpresa
                );

              this.stores = this.stores.filter((store) =>
                contratosByShoppingSelecionado.find(
                  (x) => x.numContrato == store.numContrato
                )
              ).map((item) => {
                return {
                  ...item,
                  title: `${item.nomContrato} (${item.lucLoja} - ${item.numContrato})`,
                  value: item.numContrato,
                  segmento:
                    item.idSegmentos[0] == undefined ? null : item.idSegmentos[0],
                  idSegmento:
                    item.idSegmentos[0] == undefined
                      ? null
                      : item.idSegmentos[0]['idSegmento'],
                };
              });
            }
          }
      }
      
    });
  }

  async loadComunicado(idComunicacao: number) {
    this.isLoadingMensagem = true;
    const loading = await this.loadingController.create({
      message: 'Carregando mensagem...',
    });

    loading.present();

    try {
      const { Item: comunicacaoData, erro } =
        await this.comunicacaoProvider.getComunicadoById(
          idComunicacao,
          this.MessageControl.isTarefa,
          // this.view == "consulta"
        );

      if (erro || !comunicacaoData) {
        console.error(erro);
        this.globalService.presentToast(
          'Não foi possível carregar o comunicado.',
          ToastColors.danger
        );

        return this.dismiss();
      }

      this.controleCienteProvider.updateStatusControle(idComunicacao, comunicacaoData.idTipoComunicacao, true).catch(console.error);

      comunicacaoData.comunicacaoTextos = comunicacaoData.comunicacaoTextos.map(
        (message) => {
          return {
            date: message.dataEnvioNotificacao || message.dataCriacao,
            message: this.domSanitizer.bypassSecurityTrustHtml(message.texto),
            ...message,
          } as IViewMessagesData;
        }
      ) as any;

      await this.getStores(comunicacaoData?.comunicacaoContratos[0]?.idEmpresa).catch(console.error);

      this.MessageControl = new MessageController({
        comunicacao: comunicacaoData,
        idComunicacao: this.idComunicacao,
        loadingController: this.loadingController,
        tarefa: this.tarefa,
        stores: this.stores,
        preview: false,
        view: this.view,
      });

      this.bdComunicacaoData = comunicacaoData;

      if (this.MessageControl.isReply || this.MessageControl.isRateReply || (this.view == 'consulta' && (this.MessageControl.isNotificacao || this.MessageControl.isSolicitacao))) {
        this.getReplyCommunicationText();
      }

      this.globalService.devlog('viewData', this.MessageControl.viewData);

      var notificacaoAtual = null;

      this.MessageControl.viewData.messages.forEach((element) => {
        if (this.hasSent(element.dataEnvioNotificacao, this.MessageControl.comunicacao)) {
          notificacaoAtual = element;
        }
      });

      notificacaoAtual
        ? this.currentMessage = notificacaoAtual
        : this.currentMessage = this.MessageControl.viewData.messages[0];

      this.filteredContratosDestinatarios = this.MessageControl.viewData.contratos || [];

      if (this.userConfig.isUsuarioMultiplan) {
        this.getLidos(this.idComunicacao);
      } else if (Array.isArray(comunicacaoData?.comunicacaoContratos)) {
        let contratoVisualizacao = comunicacaoData.comunicacaoContratos.filter(x => x).find(
          (contrato) =>
            contrato.numContrato == this.localStorage.user.numContrato
        );

        if (this.localStorage.user.isUsuarioMultiplan == false && contratoVisualizacao?.idEmpresa) {
          this.comunicacaoProvider
            .postLeituraComunicacaoContrato(
              this.idComunicacao,
              contratoVisualizacao.idEmpresa,
              contratoVisualizacao.numContrato
            )
            .then((response) => {
              this.globalService.devlog('Comunicação::Leitura', response);
            });
        }
      }

      this.loadRightSidebarView();
    } catch (error) {
      console.error(error);
      this.globalService.presentToast(
        'Não foi possível carregar o comunicado.',
        ToastColors.danger
      );

      return this.dismiss();
    } finally {
      this.isLoadingMensagem = false;
      loading.dismiss();
    }
  }
  async getTarefaByIdComunicacao(idComunicacao, instanceId) {
    var loading = await this.loadingController.create({
      message: 'Carregando tarefa...',
    });

    loading.present();

    try {
      const parametrosGestor = [
        {
          field: 'idComunicacao',
          operator: 'Equals',
          value: idComunicacao,
        },
        {
          field: 'instanceId',
          operator: 'Equals',
          value: instanceId,
        },
      ];

      let params: { [key: string]: any } = {};
      if (this.view == 'consulta') {
        params.loginAprovador = this.bdComunicacaoData.loginAprovador
        params.operacao = "viewConsult";
      }

      const response = await this.tarefasProvider.get(0, 50, parametrosGestor, params);

      if (response.erro || response.Item?.erro) {
        return this.globalService.publishToast({
          Mensagem: response.erro || response.Item?.erro,
          Severidade: 2,
          Posicao: 'top',
        });
      } else {
        if (
          Array.isArray(response.Item.data?.items) &&
          response.Item.data?.items.length > 0
        ) {
          const task = response.Item.data?.items[0];

          if (task) {
            return task;
          }
        }
      }
    } catch (error) {
      console.error('getTarefaByIdComunicacao', error);

      this.globalService.publishToast({
        Mensagem: error,
        Severidade: 2,
        Posicao: 'top',
      });
    } finally {
      loading.dismiss();
    }

    return null;
  }

  async cancelarComunicacao(dataLimiteCriacaoExcedida: boolean = false) {
    if (this.view != 'consulta' && (!this.tarefa || !this.tarefa?.['TASK.TKIID'])) {
      const tarefa = await this.getTarefaByIdComunicacao(
        this.idComunicacao,
        this.bdComunicacaoData.idInstanciaBpm
      );

      if (!tarefa) {
        return this.globalService.presentToast(
          'Não foi possível obter a tarefa.',
          ToastColors.danger
        );
      }

      this.tarefa = tarefa;
    }

    const taskid = this.view != "consulta" ? this.tarefa?.['TASK.TKIID'] : null;

    this.globalService.showAviso(
      `Deseja realmente cancelar esta ${this.MessageControl.descricaoTipoComunicacao} ?`,
      (isConfirm) => {
        if (isConfirm) {
          this.comunicacaoProvider
            .encerrarComunicacao(
              this.idComunicacao,
              taskid,
              this.view == 'consulta' ? true : dataLimiteCriacaoExcedida
            )
            .then((res) => {
              if (res.erro) {
                console.error(res.erro);
                this.globalService.presentToast(
                  `Falha ao cancelar ${this.MessageControl.descricaoTipoComunicacao}, tente novamente mais tarde.`,
                  ToastColors.danger
                );
              } else {
                this.globalService.presentToast(
                  `Cancelado com sucesso!`,
                  ToastColors.success
                );
                this.dismiss(true);
              }
            });
        }
      }
    );
  }

  async deletarComunicacao() {
    if(!this.canDeleteCommunication)
      return;

    this.globalService.showAviso(
      `Deseja realmente apagar esta ${this.MessageControl.descricaoTipoComunicacao} ?`,
      (isConfirm) => {
        if (isConfirm) {
          this.comunicacaoProvider
            .delete(
              this.idComunicacao
            )
            .then((res) => {
              if (res.erro) {
                console.error(res.erro);
                this.globalService.presentToast(
                  `Falha ao apagar ${this.MessageControl.descricaoTipoComunicacao}, tente novamente mais tarde.`,
                  ToastColors.danger
                );
              } else {
                this.globalService.presentToast(
                  `${this.MessageControl.descricaoTipoComunicacao} apagada com sucesso!`,
                  ToastColors.success
                );
                this.dismiss(true);
              }
            });
        }
      }
    );


  }

  async encerrarComunicacao(dataLimiteCriacaoExcedida: boolean = false) {
    if (this.view != 'consulta' && (!this.tarefa || !this.tarefa?.['TASK.TKIID'])) {
      const tarefa = await this.getTarefaByIdComunicacao(
        this.idComunicacao,
        this.bdComunicacaoData.idInstanciaBpm
      );

      if (!tarefa) {
        return this.globalService.presentToast(
          'Não foi possível obter a tarefa.',
          ToastColors.danger
        );
      }

      this.tarefa = tarefa;
    }

    const taskid = this.view != "consulta" ? this.tarefa?.['TASK.TKIID'] : null;

    this.globalService.showAviso(
      `Deseja realmente encerrar esta ${this.MessageControl.descricaoTipoComunicacao} ?`,
      async (isConfirm) => {
        if (isConfirm) {
          let loading = await this.globalService.showLoading();
          this.comunicacaoProvider
            .encerrarComunicacao(
              this.idComunicacao,
              taskid,
              this.view == 'consulta' ? true : this.MessageControl.limitDateExceeded
            )
            .then((res) => {
              if (res.erro) {
                console.error(res.erro);
                this.globalService.presentToast(
                  `Falha ao encerrar ${this.MessageControl.descricaoTipoComunicacao}, tente novamente mais tarde.`,
                  ToastColors.danger
                );
              } else {
                this.globalService.presentToast(
                  `${this.MessageControl.descricaoTipoComunicacao} encerrada com sucesso!`,
                  ToastColors.success
                );
                this.dismiss(true);
              }
            })
            .finally(() => {
              loading.dismiss();
            })
        }
      }
    );
  }

  preReplyMessage(response: 'aprovar' | 'reprovar' | 'reprovarMsg') {
    if (
      this.MessageControl.limitDateExceeded === true &&
      response == 'aprovar' &&
      this.MessageControl.isRateReply == false
    ) {
      this.globalService.showAviso(
        {
          titulo: 'Aviso',
          message:
            'A tarefa não pode ser aprovada em função do vencimento da data limite. Favor editar a data limite clicando em confirmar ou através da opção "Editar".',
        },
        (onConfirm) => {
          if (onConfirm) {
            this.onEditComm();
          }
        }
      );

      return;
    }

    if (
      this.MessageControl.isNotificacao
      && (this.MessageControl.MESSAGE_STAGE == MESSAGE_STAGE_ENUM.AJUSTAR_CRIACAO || this.MessageControl.MESSAGE_STAGE == MESSAGE_STAGE_ENUM.AVALIAR_CRIACAO)
      && response == 'aprovar'
    ) {
      var dataAtual = new Date().toISOString().split("T")[0] + "T00:00:00"
      if (new Date(this.MessageControl.viewData.messages[this.getIndexNotificacaoAtual()].dataEnvioNotificacao).getTime() < new Date(dataAtual).getTime()) {
        this.globalService.showAviso(
          {
            titulo: 'Aviso',
            message:
              'A notificação não pode ser aprovada pois a data de envio é anterior à atual. Favor editar a notificação clicando em confirmar ou através da opção "Editar".',
          },
          (onConfirm) => {
            if (onConfirm) {
              this.onEditComm();
            }
          }
        );

        return;
      }
    }

    let nomeTipo = 'o comunicado';

    switch (this.MessageControl.viewData.tipoComunicado) {
      case IdTipoComunicado.Comunicado:
        nomeTipo = 'o comunicado';
        break;
      case IdTipoComunicado.Notificação:
        nomeTipo = 'a notificação';
        break;
      case IdTipoComunicado.Promoção:
        nomeTipo = 'a promoção';
        break;
      case IdTipoComunicado.Solicitação:
        nomeTipo = 'a solicitação';
        break;
    }

    this.globalService.showAviso(
      `Deseja realmente ${response === 'aprovar' ? 'aprovar' : 'reprovar'} ${
        this.MessageControl.isRateReply ? 'a resposta' : nomeTipo
      }?`,
      (isConfirm) => {
        if (isConfirm) {
          this.onReplyComm(response);
        }
      }
    );
  }

  async changeLimitDate() {
    if (!this.dataLimiteAtualizacao) {
      this.globalService.presentToast(
        'Informe a data limite.',
        ToastColors.danger
      );
      return;
    }

    if (this.dataLimiteAtualizacao) {
      if (this.dataLimiteAtualizacao.length < 10) {
        this.globalService.presentToast(
          'Informe a data limite.',
          ToastColors.danger
        );
        return;
      }

      let dataLimite = new Date(this.dataLimiteAtualizacao);
      let dataAtual = new Date();

      if (dataLimite < dataAtual) {
        this.globalService.presentToast(
          'A data limite não pode ser menor que a data atual.',
          ToastColors.danger
        );
        return;
      }
    }

    let loading = await this.loadingController.create({
      message: 'Aguarde...',
    });

    loading.present();

    this.tarefasProvider
      .alteracaoDataLimite(
        this.tarefa['TASK.TKIID'],
        this.idComunicacao,
        this.justificativaAlteracaoDataLimite,
        this.dataLimiteAtualizacao
      )
      .then((res) => {
        if (res.erro) {
          this.globalService.presentToast(res.erro, ToastColors.danger);
        } else {
          this.globalService.presentToast(
            'Data limite alterada com sucesso!',
            ToastColors.success
          );
          this.setOpenModalAlterarDataLimite(false);
          this.events.publish('communication.getTarefas', {});
          this.modalCtrl.dismiss(
            undefined,
            undefined,
            'message-comunicacao-modal'
          ); //sem o id o modalCtrl nao usa a referencia correta
        }
      })
      .catch((err) => {
        this.globalService.presentToast(
          'Não foi possível alterar a data limite.',
          ToastColors.danger
        );
        this.globalService.devlog(err);
      })
      .finally(() => {
        loading.dismiss();
      });
  }

  async onReplyComm(response: 'aprovar' | 'reprovar' | 'reprovarMsg') {
    let loading = await this.loadingController.create({
      message: 'Aguarde...',
    });

    loading.present();

    if (response == 'reprovarMsg') {
      loading.dismiss();

      this.setOpenModalReprovacao(true);
      return;
    }

    this.isModalReprovacao = false;

    this.tarefasProvider
      .avaliarComunicacao(
        response == 'aprovar',
        this.tarefa.bdiD_COMUNICACAO ||
          this.tarefa.bdiD_AUTORIZACAO_SERVICO ||
          this.tarefa.idComunicacao,
        this.tarefa['TASK.TKIID'] || this.tarefa.idInstanciaBpm,
        {
          justificativa: this.justificativaReprovacao,
          ...(this.MessageControl.isRateReply && {
            operacao: 'avaliarResposta',
          }),
          idComunicacao: this.idComunicacao,
          idEmpresa:
            this.MessageControl.viewData.contratos[0]?.idEmpresaNavigation
              ?.idEmpresa,
          numContrato: this.MessageControl.taskContractNumber,
        }
      )
      .then((res) => {
        if (res.erro) {
          this.globalService.presentToast(res.erro, ToastColors.danger);
        } else {
          let idResp = `${this.MessageControl.viewData.tipoComunicado}_${
            response == 'aprovar' ? 'APROVADA' : 'REPROVADA'
          }`;
          let respMessage = messages.COMUNICACAO.APROVACAO_REPROVACAO[idResp];

          this.globalService.presentToast(
            `${
              this.MessageControl.isRateReply ? 'Resposta de ' : ''
            }${respMessage}`,
            ToastColors.success
          );
          this.dismiss(true);
          this.events.publish('communication.getTarefas', {});
        }
      })
      .catch((err) => {
        if (err.erro) {
          this.globalService.presentToast(err.erro, ToastColors.danger);
        } else {
          this.globalService.presentToast(
            'Não foi possível responder o comunicado.',
            ToastColors.danger
          );
        }

        this.globalService.devlog(err);
        this.dismiss(true);
      })
      .finally(() => {
        this.dismiss(true);
        loading.dismiss();
      });
  }

  async getReplyCommunicationText() {
    try {
      const responseReply =
        await this.comunicacaoProvider.getReplyTextComunicacao({
          idComunicacao: this.idComunicacao,
          idEmpresa:
            this.MessageControl.viewData.contratos[0]?.idEmpresaNavigation
              ?.idEmpresa,
          numContrato: this.MessageControl.taskContractNumber ? this.MessageControl.taskContractNumber : this.numContrato,
        });

      if (Array.isArray(responseReply) && responseReply.length) {
        this.replyTextHistory = responseReply.map((message) => {
          return {
            date:
              message.idTextoNavigation.dataEnvioNotificacao ||
              message.idTextoNavigation.dataCriacao,
            message: this.domSanitizer.bypassSecurityTrustHtml(
              message.idTextoNavigation.texto
            ),
            arquivos:
              this.MessageControl.comunicacao.comunicacaoArquivos.filter(
                (arq) => arq.idTexto == message.idTexto
              ),
            ...message,
          } as IViewMessagesData;
        }) as any;

        this.MessageControl.viewData.arquivos =
          this.MessageControl.comunicacao.comunicacaoArquivos.filter(
            (x) =>
              !!this.replyTextHistory.find((r) =>
                r.arquivos.find((a) => a.idTexto != x.idTexto)
              )
          );
      } else {
        this.replyTextHistory = [];
      }
    } catch (error) {
      console.error(error);
    } finally {
      // loading.dismiss();
    }
  }

  async replyCommunicationText() {
    if (this.MessageControl.isPromocao) {
      if (this.replyQueroParticipar !== null) {
        if (
          this.replyQueroParticipar === 'sim' &&
          this.bdComunicacaoData.flgAnexoRespostaPromocaoSim === true &&
          this.pickedDocuments.length === 0
        ) {
          this.globalService.presentToast(
            'É necessário enviar um anexo nesta resposta.',
            ToastColors.danger
          );
          return;
        }

        if (
          this.replyQueroParticipar === 'nao' &&
          this.bdComunicacaoData?.flgAnexoRespostaPromocaoNao === true &&
          this.pickedDocuments.length == 0
        ) {
          this.globalService.presentToast(
            'É necessário enviar um anexo nesta resposta.',
            ToastColors.danger
          );
          return;
        }
      } else {
        this.globalService.presentToast(
          'É necessário informar se deseja participar ou não desta promoção.',
          ToastColors.danger
        );
        return;
      }
    } else {
      if (
        this.bdComunicacaoData?.flgAnexoResposta === true &&
        this.pickedDocuments.length == 0
      ) {
        this.globalService.presentToast(
          'É necessário enviar um anexo nesta resposta.',
          ToastColors.danger
        );
        return;
      }
    }

    if (!this.replyText) {
      this.globalService.presentToast(
        'É necessário informar uma mensagem nesta resposta.',
        ToastColors.danger
      );
      return;
    }

    this.globalService.showAviso(
      {
        mensagem: this.MessageControl.currentUserIsCriador
          ? 'Deseja realmente responder pelo lojista?'
          : `Deseja realmente responder esta ${this.MessageControl.descricaoTipoComunicacao} ?`,
      },
      (onConfirm) => {
        if (onConfirm) {
          this.envioResposta();
        }
      }
    );
  }


    async openDetailAuditModal(data) {
      const modal = await this.modalCtrl.create({
        component: AuditDetailPage,
        componentProps: {
          activeAuditDetail: data,
        },
        cssClass: 'smallModal'
      })
  
      modal.onDidDismiss().then((res) => {
        if(res.data && res.data.refresh)
        {
          //this.search(null, true);
        }
      });
  
      await modal.present();
    }

  async envioResposta() {
    const loading = await this.loadingController.create({
      message: 'Aguarde...',
    });

    loading.present();

    try {
      const texto = {
        IdTexto: null,
        IdTipoTexto: 3,
        Texto: this.replyText,
        IdStatusComunicacaoTexto: 1,
      };

      const postFiles = [];

      for await (const file of this.pickedDocuments) {
        if (file.idGestorDocumentos) continue;

        try {
          const base64 = await DevUtils.fileToBase64(file);

          postFiles.push({
            base64,
            fileName: file.name,
          });
        } catch (error) {
          //console.log(error);
        }
      }

      const responseReply = await this.comunicacaoProvider.responderComunicacao(
        {
          idComunicacao: this.idComunicacao,
          idEmpresa:
            this.MessageControl.viewData.contratos[0]?.idEmpresaNavigation
              ?.idEmpresa,
          numContrato: this.MessageControl.taskContractNumber,
          queroParticipar: this.MessageControl.isPromocao
            ? this.replyQueroParticipar === 'sim'
              ? true
              : false
            : null,
          idAtividade: this.MessageControl.tarefa?.tkiid,
        },
        {
          comunicacaoTexto: texto,
          arquivos: postFiles,
        }
      );

      if (responseReply.erro) {
        this.globalService.presentToast(responseReply.erro, ToastColors.danger);
        return;
      }

      const alert = await this.AlertController.create({
        header: 'Sucesso!',
        message: `${this.MessageControl.descricaoTipoComunicacao} respondida com sucesso.`,
        buttons: [
          {
            text: 'Confirmar',
            role: 'confirm',
            handler: () => {
              this.dismiss(true);
            },
          },
        ],
      });

      await alert.present();
    } catch (error) {
      console.error(error);

      this.globalService.presentToast(
        'Não foi possível responder o comunicado.',
        ToastColors.danger
      );
    } finally {
      loading.dismiss();
    }
  }
  async onEditComm() {
    var atualizaDataNotifIndex = 0

    if (this.MessageControl.isNotificacao && (this.MessageControl.MESSAGE_STAGE == MESSAGE_STAGE_ENUM.AJUSTAR_CRIACAO || this.MessageControl.MESSAGE_STAGE == MESSAGE_STAGE_ENUM.AVALIAR_CRIACAO)) {
      atualizaDataNotifIndex = this.getIndexNotificacaoAtual();
    }

    let modal = await this.modalCtrl.create({
      component: CreatecomunicadoPage,
      componentProps: {
        comunicado: this.bdComunicacaoData,
        comunicadoId: this.idComunicacao,
        isEdit: true,
        editNotifIndex: atualizaDataNotifIndex,
        taskId: this.tarefa['TASK.TKIID'],
        tarefa: this.tarefa,
        type: this.bdComunicacaoData.idTipoComunicacao,
      },
      cssClass: 'bigModal',
    });

    modal.onDidDismiss().then((res) => {
      if (res.data.editado) {
        this.loadComunicado(this.idComunicacao);

        if (this.MessageControl.currentUserIsCriador) {
          this.comunicadoEditado = true;
        }
      }
    });

    await modal.present();
  }

  public get lojasParticipantes() {
    return this.todasLeituras.filter(
      (leitura) => leitura.comunicacaoContrato?.statusRespostaPromocao == 'S'
    );
  }
  public get lojasNaoParticipantes() {
    return this.todasLeituras.filter(
      (leitura) => leitura.comunicacaoContrato?.statusRespostaPromocao == 'N'
    );
  }

  public get lojasPendentesResposta() {
    return this.todasLeituras.filter((leitura) =>
      ['S', 'N'].includes(leitura.comunicacaoContrato?.statusRespostaPromocao)
    );
  }
  async getLidos(idComunicacao: number) {
    this.loadingLeituras = true;

    return this.comunicacaoProvider
      .getLidos(idComunicacao)
      .then(({ lidos: leiturasArray }) => {
        if (Array.isArray(leiturasArray)) {
          const contratosMap = new Map();
          const lidosMap = leiturasArray.filter(leitura => {
            const contrato = leitura.comunicacaoContrato?.contrato;

            if(!contrato)
              return false;

            const key = JSON.stringify(contrato.numContrato);

            if(contratosMap.has(key))
            {
              const lido = contratosMap.get(key).lido;

              if(lido == true) // o que está adicionado já é true (LIDO)
                return false;

              if(leitura.lido == false) // o que está salvo é false (NÃO LIDO) e o que está para adicionar é false (NÃO LIDO);
                return false;

              return false;
            }

            contratosMap.set(key, {lido: leitura.lido});

            return true;
          }).map((leitura) => {
            return {
              ...leitura,
              contrato: leitura.comunicacaoContrato?.contrato,
            };
          });

          const lidos = lidosMap.filter((x) => x.lido == true);

          const contratos = this.MessageControl?.viewData?.contratos || [];

          const contratosNaoLidos = contratos.filter(c => !lidos.find(l => l.contrato.numContrato == c.numContrato)).map(contrato => {

            return {
              "idComunicacao": idComunicacao,
              "idLogin": null,
              "lido": false,
              "dataLeitura": null,
              "numContrato": contrato.numContrato,
              "idEmpresa": contrato.idEmpresa,
              "loginUsuario": contrato.idCliente,
              "nomeUsuario": "LOJISTA",
              "contrato": {
                "numContrato": contrato.numContrato,
                "lucLoja": contrato.lucLoja,
                "tipoContrato": contrato.tipoContrato,
                "dtRescisao": null,
                "dtInicioPeriodo": "2010-11-01T12:00:00",
                "dtFimPeriodo": "9999-12-31T12:00:00",
                "idEmpresa": contrato.idEmpresa,
                "nomContrato": contrato.nomContrato,
                "idCliente": contrato.idCliente,
                "numMaxDeUsuarios": 4,
                "idClienteNavigation": null,
                "idEmpresaNavigation": {
                    "idEmpresa": contrato.idEmpresa,
                    "nomEmpresa": contrato.idEmpresaNavigation?.nomEmpresa,
                    "dtAberturaLoja": "2024-07-01T00:00:00",
                    "dtAberturaAdm": "2024-05-01T00:00:00",
                }
            },
              "comunicacaoContrato": {
                  "idComunicacao": idComunicacao,
                  "numContrato": contrato.numContrato,
                  "idEmpresa": contrato.idEmpresa,
                  "statusRespostaPromocao": null,
                  "dataLimiteRespostaPromocao": null,
                  "flgRespostaAceitaPromocao": null,
                  "loginUsuarioRespondeuPromocao": null,
                  "nomeUsuarioRespondeuPromocao": null,
                  "dataRespostaPromocao": null,
                  "gravarLeituraLojista": true,
                  "contrato": {
                      "numContrato": contrato.numContrato,
                      "lucLoja": contrato.lucLoja,
                      "tipoContrato": contrato.tipoContrato,
                      "dtRescisao": null,
                      "dtInicioPeriodo": "2010-11-01T12:00:00",
                      "dtFimPeriodo": "9999-12-31T12:00:00",
                      "idEmpresa": contrato.idEmpresa,
                      "nomContrato": contrato.nomContrato,
                      "idCliente": contrato.idCliente,
                      "numMaxDeUsuarios": 4,
                      "idClienteNavigation": null,
                      "idEmpresaNavigation": {
                          "idEmpresa": contrato.idEmpresa,
                          "nomEmpresa": contrato.idEmpresaNavigation?.nomEmpresa,
                          "dtAberturaLoja": "2024-07-01T00:00:00",
                          "dtAberturaAdm": "2024-05-01T00:00:00",
                      }
                  },
              }
          }
          })

          this.leituras.naoLidas = contratosNaoLidos;
          this.leituras.lidas = lidos;
          this.todasLeituras = lidosMap;
        }
      })
      .finally(() => {
        this.loadingLeituras = false;
      });
  }

  async previewFile(file) {
    const loading = await this.loadingController.create({
      message: 'Carregando...',
    });

    loading.present();

    this.comunicacaoProvider
      .getFilesByIds([file.idComunicacaoArquivo])
      .then((res) => {
        if (Array.isArray(res.rows) && res.rows.length > 0) {
          const file = res.rows[0];

          if (this.isMobile) {
            const url = file.urlDownload;
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', file.nome);
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            const url = file.urlVisualizacao;
            window.open(url, '_blank');
          }
        } else {
          this.globalService.devconsole('Arquivo não encontrado', res);

          this.globalService.presentToast(
            'Arquivo não encontrado para visualização',
            ToastColors.tertiary
          );
        }
      })
      .finally(() => {
        loading.dismiss();
      });
  }

  pickedDocuments = [];
  async onPickFile() {
    if (this.pickedDocuments.length === 5) {
      alert('Limite de arquivos atingido');
      return;
    }

    this.inputFile.nativeElement.click();
  }

  async removeFile(index: number) {
    const file = this.pickedDocuments[index];

    if (file.isEditFile) {
    }

    this.pickedDocuments.splice(index, 1);
  }

  async addFile($event) {
    const file = this.inputFile.nativeElement.files[0];

    const TEN_MB_IN_BYTES = 10000000;

    if (file.size > TEN_MB_IN_BYTES) {
      alert('Arquivo muito grande');
      return;
    }

    this.pickedDocuments = this.pickedDocuments.concat(file);
  }

  async onSendAdjust() {
    const loading = await this.loadingController.create({
      message: 'Carregando...',
    });

    loading.present();

    try {
      const res = await this.tarefasProvider.responderTarefa(false, {
        operacao: 'ajustarComunicacao',
        idComunicacao: this.idComunicacao,
        idAtividadeBPM: this.tarefa['TASK.TKIID'],
      });

      if (res?.erro) {
        this.globalService.presentToast(res.erro, ToastColors.danger);
      } else {
        this.globalService.presentToast(
          'Comunicado ajustado com sucesso!',
          ToastColors.success
        );
        this.dismiss(true);
      }
    } catch (error) {
      this.globalService.presentToast(
        'Não foi possível ajustar o comunicado.',
        ToastColors.danger
      );
      this.globalService.devlog(error);
      this.loadingController.dismiss();
    } finally {
      loading.dismiss();
    }
  }

  async onGoToAuditoria() {
    // Fluxo Comunicação -> Auditoria: confirma com o usuário antes de redirecionar.
    const alert = await this.AlertController.create({
      header: 'Atenção',
      message: 'Você será redirecionado para a tela de Auditoria. Deseja continuar?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: async () => {
            // Envia o idComunicacao da tela Comunicação como codigoItem para filtrar na Auditoria.
            const idComunicacao = this.idComunicacao ? `${this.idComunicacao}` : '';

            await this.modalCtrl.dismiss();

            // Abre a tela de Auditoria com query param para pré-preencher os filtros.
            this.router.navigate(['/auditoria'], {
              queryParams: {
                codigoItem: idComunicacao,
              },
            });
          },
        },
      ],
    });

    await alert.present();
  }

  dismiss(refreshList = false) {
    this.modalCtrl.dismiss({refreshList});
  }

  print() {
    window.print();
  }

  async abrirLeitura(leitura) {
    const lista = leitura.idComunicacaoNavigation?.comunicacaoLeituras?.filter(l => l.numContrato == leitura.numContrato) || [];

    // leitura.idComunicacaoNavigation.comunicacaoLeituras.forEach((element) => {
    //   if (element.numContrato == leitura.numContrato) {
    //     temp.push(element);
    //   }
    // });

    const popover = await this.popoverController.create({
      component: TimelinereadPage,
      cssClass: 'popover-status',
      arrow: false,
      showBackdrop: false,
      componentProps: {
        lista,
        numContrato: leitura.numContrato,
        lucLoja: leitura.lucLoja,
      },
    });
    return await popover.present();
  }

  getNotificacaoAtual() {
    var notificacaoAtual = null;

    this.MessageControl.viewData.messages.forEach((element, index) => {
      if (this.hasSent(element.dataEnvioNotificacao, this.MessageControl.comunicacao)) {
        notificacaoAtual = 'message' + index;
      }
    });

    return notificacaoAtual ? notificacaoAtual : 'message' + 0;
  }

  getIndexNotificacaoAtual() {
    var notificacaoAtual = null;

    this.MessageControl.viewData.messages.forEach((element, index) => {
      if (this.hasSent(element.dataEnvioNotificacao, this.MessageControl.comunicacao)) {
        notificacaoAtual = index;
      }
    });

    return notificacaoAtual ? notificacaoAtual : 0;
  }

  // dataNotif | dataAtual | dataNotif + 1
  areDatesSequential(date1, date2, date3) {
    try {
      const parsedDate1 = new Date(date1);
      const parsedDate2 = new Date(date2);
      const parsedDate3 = new Date(date3);

      if (
        isNaN(parsedDate1.getTime()) ||
        isNaN(parsedDate2.getTime()) ||
        isNaN(parsedDate3.getTime())
      )
        return false;

      return (
        (isBefore(parsedDate1, parsedDate2) ||
          isSameDay(parsedDate1, parsedDate2)) &&
        isBefore(parsedDate2, parsedDate3)
      );
    } catch (_) {
      return false;
    }
  }

  hasSent(dateString: string, jsonComunicado: any) {
    if (!jsonComunicado?.flgAprovado) {
      return false;
    }

    var date = dateString && new Date(dateString);
    var approvalDate = jsonComunicado?.comunicacaoTextos.find(item => item.idTipoTexto == 1 && item.dataEnvioNotificacao == dateString)
      && new Date(jsonComunicado.comunicacaoTextos.find(item => item.idTipoTexto == 1 && item.dataEnvioNotificacao == dateString).dataEnvioNotificacao);

    if (!date || !approvalDate) {
      return false;
    } else if (isNaN(date.getTime()) || isNaN(approvalDate.getTime())) {
      return false;
    }

    let currentDate = new Date(this.currentDate + 'T00:00:00');

    if (
      this.MessageControl.MESSAGE_STAGE == MESSAGE_STAGE_ENUM.CONFIRMAR_NOTIFICACAO
      && isSameDay(date, currentDate)
    ) {
      return false;
    }

    return (
      (isBefore(date, currentDate) || isSameDay(date, currentDate)) &&
      (isBefore(date, approvalDate) || isSameDay(approvalDate, date))
    );
  }

  hasReproved(msg, jsonComunicado) {
    if (!jsonComunicado?.comunicacaoTextos || jsonComunicado?.comunicacaoTextos[jsonComunicado.comunicacaoTextos.length-1]?.idTipoTexto != 2) {
      return false;
    }

    var dataReprovacao = new Date(jsonComunicado.comunicacaoTextos[jsonComunicado.comunicacaoTextos.length-1].dataCriacao.split('T')[0] + "T00:00:00")
    var dataReprovacaoFull = new Date(jsonComunicado.comunicacaoTextos[jsonComunicado.comunicacaoTextos.length-1].dataCriacao);
    var dataEnvioNotificacao = new Date(msg.dataEnvioNotificacao);

    if (msg.dataAlteracao) {
      var dataAlteracao = new Date(msg.dataAlteracao);

      if (dataAlteracao.getTime() < dataReprovacaoFull.getTime()) {
        if (dataEnvioNotificacao.getTime() > dataReprovacao.getTime()) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    } else {
      if (dataEnvioNotificacao.getTime() > dataReprovacao.getTime()) {
        return false
      } else {
        return true
      }
    }
  }
}
